// import axios from "../../utils/axiosConfig";
// import { LoginDTO } from "../../dtos/auth";
// import { VerifyOTPDTO } from "../../dtos/doctor";

// const login = async (dto: LoginDTO) => {
//   const { data } = await axios.post("/api/auth/send-verification-code", dto);
//   return data;
// };
// const verifyOTP = async (dto: VerifyOTPDTO) => {
//   const config = {
//     headers: {
//       "Access-Control-Allow-Credentials": true,
//       crossorigin: true,
//     },
//   };
//   const { data } = await axios.post("/api/auth/verify-otp-code", dto, config);
//   return data;
// };
// const logout = async () => {
//   const { data } = await axios.post("/api/auth/logout");
//   return data;
// };

// const authService = {
//   login,
//   verifyOTP,
//   logout,
// };

// export default authService;



import axios from "../../utils/axiosConfig";
import { ForgetPasswordDTO, ForgetPasswordOtpDTO, LoginDTO, UpdatePasswordDTO,ResetPasswordDTO, SignUpDTO, VerifyOTPSignUpDTO } from "../../dtos/auth";
import { VerifyOTPDTO } from "../../dtos/doctor";

// const login = async (dto: LoginDTO) => {
//   const { data } = await axios.post("/api/auth/send-verification-code", dto);
//   return data;
// };
const login = async (dto: LoginDTO) => {
  const { data } = await axios.post("/api/pharmacy/login", dto);
  return data;
};
const forgetPassword = async (dto: ForgetPasswordDTO) => {
  const { data } = await axios.post("/api/pharmacy/forget_password", dto);
  return data;
};
const forgetPasswordOtp = async (dto: ForgetPasswordOtpDTO) => {
  const { data } = await axios.post("/api/pharmacy/otp_verification", dto);
  return data;
};
const resetPassword = async (dto: ResetPasswordDTO) => {
  const { data } = await axios.put("/api/pharmacy/reset_password", dto);
  return data;
};
const updateInternalPassword = async (dto: UpdatePasswordDTO) => {
  const { data } = await axios.put("/api/pharmacy/update_internal_password", dto);
  return data;
}
const signUp = async (dto: SignUpDTO) => {
  const { data } = await axios.post("/api/pharmacy/signup", dto);
  return data;
};
const signUpVerifyOTP = async (dto: VerifyOTPSignUpDTO) => {
  const config = {
    headers: {
      "Access-Control-Allow-Credentials": true,
      crossorigin: true,
    },
  };
  const { data } = await axios.post("/api/pharmacy/verify_otp", dto, config);
  return data;
};
const verifyOTP = async (dto: VerifyOTPDTO) => {
  const config = {
    headers: {
      "Access-Control-Allow-Credentials": true,
      crossorigin: true,
    },
  };
  const { data } = await axios.post("/api/auth/verify-otp-code", dto, config);
  return data;
};

const logout = async (bearerToken: string , staff_token: string) => {
  const { data } = await axios.post(
    "/api/pharmacy/logout",
    {staff_token},
    {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    }
  );
  return data;
};



const authService = {
  login,
  forgetPassword,
  forgetPasswordOtp,
  resetPassword,
  signUp,
  updateInternalPassword,
  signUpVerifyOTP,
  verifyOTP,
  logout,
};

export default authService;

